import { useEffect } from "react"
import { FontAwesomeIcons } from "../../core/Types"
import Icon from "../base/Icon"
import { CallListener } from "../../modules/voice/calls/models/Call"
import Avatar from "../base/Avatar"
import { toPrettyDate } from "../../core/Global"
import FlexRow from "../base/FlexRow"
import { Link, useNavigate } from "react-router-dom"


export interface MenuItem {
    id?: string
    title: string
    subtext?: string
    icon?: FontAwesomeIcons
    iconColor?: string
    iconType?: "solid" | "regular" | "light" | "thin" | "brands"
    danger?: boolean
    // Yellow, for a cautionary action that is not destructive (e.g. Block).
    warning?: boolean
    visible?: boolean
    to?: string
    redirect?: string
    avatar?: string
    action?: () => void
    click?: (e: any) => Promise<void>
}
interface IProps {
    source?: MenuItem[]
    listerns?: CallListener[]
    width?: number
    scroll?: boolean
    keepOpen?: boolean
    selectedIds?: string[]
}

export default function DropdownMenu(props: IProps) {

    const navigate = useNavigate();

    useEffect(() => {
        //window.dataTableMenu()
    }, [])

    return (
        <div className="menu menu-sub menu-sub-dropdown menu-column fw-bold fs-7 p-0 m-0"
            data-kt-menu="true" data-kt-menu-permanent="true"
            style={{
                width: props.width ?? 150,
                maxWidth: props.width ?? 150,
            }}
        >
            <div className={props.scroll ? "scroll-y noscrollbar" : ""} style={{
                maxHeight: props.scroll ? 250 : undefined
            }}>

                {
                    props.source?.filter(f => f.visible == undefined || f.visible).map((item, key) =>
                        <div key={key}
                            className={`menu-item m-0 ${(item.id && props.selectedIds && props.selectedIds.includes(item.id) ? "bg-secondary" : "")}`}>
                            {/* {
                                item.to ?
                                    <Link to={item.to} className={"menu-link px-3 " + (item.danger ? "text-danger" : item.warning ? "text-warning" : "text-gray-700")}>
                                        <Icon icon={item.icon} className={"me-2 " + (item.danger ? "text-danger" : item.warning ? "text-warning" : !item.iconColor ? "text-gray-700" : "")}
                                            type={item.iconType ?? "solid"} minWidth={13} color={item.iconColor} />
                                        {item.title}
                                    </Link>
                                    :
                                    
                            } */}

                            <a href={item.redirect ? item.redirect : "#"} target={item.redirect ? "_blank" : undefined}
                                className={"menu-link d-flex align-items-center px-3 " + (item.danger ? " text-danger" : item.warning ? " text-warning" : "text-gray-700")}
                                onClick={item.redirect ? undefined : item.click ? item.click : e => {
                                    e.preventDefault();
                                    if (item.to) navigate(item.to)
                                    if (item.action) item.action()

                                }}
                            >
                                {
                                    item.avatar ?
                                        <Avatar avatarUrl={item.avatar} width={30} className="me-2" />
                                        :
                                        <Icon icon={item.icon} className={"me-2 " + (item.danger ? " text-danger" : item.warning ? " text-warning" : !item.iconColor ? "text-gray-700" : "")}
                                            type={item.iconType ?? "solid"} minWidth={13} color={item.iconColor} />
                                }

                                <div>
                                    <div>{item.title}</div>
                                    {
                                        item.subtext &&
                                        <div className="text-muted fw-normal fs-8">{item.subtext}</div>
                                    }
                                </div>

                                {
                                    item.id && props.selectedIds && props.selectedIds.includes(item.id) &&
                                    <Icon icon="check" className="ms-auto me-3" />
                                }
                            </a>

                        </div>
                    )
                }

                {
                    props.listerns?.map((item, key) =>
                        <div key={key} className="menu-item m-0">
                            <FlexRow className="menu-link text-gray-700 px-3">
                                <Avatar fullName={item.user?.fullName} avatarUrl={item.user?.avatarUrl} width={20} className="me-2" />
                                <span className="fw-normal max-100 limited-text text-gray-700">
                                    {item.user?.fullName}
                                </span>
                                <span className="text-muted fs-9 ms-auto">
                                    {toPrettyDate(item.listenedAt)}
                                </span>
                            </FlexRow>
                        </div>
                    )
                }

            </div>
        </div>
    )
}